import { render } from "./GithubRepositories.vue?vue&type=template&id=40db66b3"
import script from "./GithubRepositories.vue?vue&type=script&lang=js"
export * from "./GithubRepositories.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/leandro-gomez.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__